import { useState } from 'react'
import { Row, Col, Button } from 'antd'

import Text from '~/core/Text'
import { ExceptionListDetailsType } from '../types'
import styles from '../styles.css'
import { tailTruncate } from '~/lib/middleTruncate'
export const ExceptionsListDetails = (props: ExceptionListDetailsType) => {
    const { content, title, isLongText } = props
    const [expanded, setExpanded] = useState(false)
    const maxTextLength = 150
    const showLessText = 'Show less'
    const showMoreText = 'Show more'

    return (
        <Row style={{ paddingBottom: '4px' }}>
            <Col
                style={{
                    width: '214px',
                }}
            >
                <Text className={styles.exceptionFailureFieldLabel}>
                    {title}
                </Text>
            </Col>
            {isLongText ? (
                content &&
                typeof content === 'string' && (
                    <Col>
                        <Text className={styles.exceptionFailureFieldValue}>
                            {expanded
                                ? content
                                : tailTruncate(content, maxTextLength, '...')}
                        </Text>
                        {content.length >= maxTextLength && (
                            <>
                                {' '}
                                <Button
                                    type="text"
                                    onClick={() => setExpanded(!expanded)}
                                    className={
                                        styles.exceptionNotesExpandCollapse
                                    }
                                >
                                    {expanded ? showLessText : showMoreText}
                                </Button>
                            </>
                        )}
                    </Col>
                )
            ) : (
                <Col>
                    <Text className={styles.exceptionFailureFieldValue}>
                        {content}
                    </Text>
                </Col>
            )}
        </Row>
    )
}
